import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-4" }

import { reactive, watch, ref } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactNameForm',
  props: {
    contactName: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['inputValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const contactNameValue = ref('');
const data = reactive({ contact_name: contactNameValue });

const unwatch = watch(
  () => props.contactName,
  (propsContactName) => {
    contactNameValue.value = propsContactName;
    unwatch();
  }
);
watch(contactNameValue, () => {
  data.contact_name = contactNameValue.value;
  emit('inputValue', data);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: __props.windowInnerWidth > 800 ? 2 : 3
      }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.contactName')), 1)
        ]),
        _: 1
      }, 8, ["cols"]),
      _createVNode(_component_v_col, {
        cols: __props.windowInnerWidth > 800 ? 10 : 9
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: contactNameValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactNameValue).value = $event)),
            maxlength: "255",
            "error-messages": __props.errors?.contact_name
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _: 1
      }, 8, ["cols"])
    ]),
    _: 1
  }))
}
}

})